// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorMessage_errorContainer__VPeV3"};